import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Paper, Typography, Box } from '@mui/material';

import { SwitchBox } from '../../molecules/switch-box';
import { InputBox } from '../../molecules/input-box';
import { Group } from '../../organisms/group';
import { ServiceAccessInput } from '../../organisms/settings/service-access-input';
import { useSelector } from '../../store/utils';

const DevEnerco = () => {
  const [
    serviceActive,
    enabled,
    sharingGroupName,
    predictionDate,
    consumption,
    production,
    lastFetch,
  ] = useSelector(
    ({ variables }) =>
      [
        variables.SERVICE_ACTIVE,
        variables.ENERCO_INTEGRATION_ENABLED,
        variables.ENERCO_SHARING_GROUP_NAME,
        variables.ENERCO_PREDICTION_DATE,
        variables.ENERCO_CONSUMPTION_PREDICTION,
        variables.ENERCO_PRODUCTION_PREDICTION,
        variables.ENERCO_PREDICTION_LAST_FETCH,
      ] as const
  );

  if (!serviceActive) {
    return (
      <Group
        layout="list"
        title={
          <FormattedMessage
            id="dev_homepage.title"
            defaultMessage="Vývojové menu"
          />
        }
      >
        <ServiceAccessInput />
      </Group>
    );
  }

  return (
    <>
      <Group
        layout="list"
        title={<FormattedMessage id="enerco.title" defaultMessage="Enerco" />}
      >
        <SwitchBox
          switchVariableId="ENERCO_INTEGRATION_ENABLED"
          title={
            <FormattedMessage
              id="enerco.enabled"
              defaultMessage="Integrace zapnuta"
            />
          }
          fullWidth
        />
        <InputBox
          inputVariableId="ENERCO_EAN"
          title={<FormattedMessage id="enerco.ean" defaultMessage="EAN" />}
          placeholder="859182400000000000"
        />
      </Group>

      <Group
        layout="list"
        title={
          <FormattedMessage
            id="enerco.prediction.title"
            defaultMessage="Predikce"
          />
        }
      >
        <Paper>
          <Box sx={{ p: 2 }}>
            {!enabled ? (
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                <FormattedMessage
                  id="enerco.prediction.disabled"
                  defaultMessage="Integrace je vypnutá."
                />
              </Typography>
            ) : (
              <>
                <Typography variant="body2">
                  Sdílecí skupina: {sharingGroupName || '—'}
                </Typography>
                <Typography variant="body2">
                  Datum: {predictionDate || '—'}
                </Typography>
                <Typography variant="body2">
                  Poslední aktualizace:{' '}
                  {lastFetch ? new Date(lastFetch).toLocaleString() : '—'}
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Spotřeba (komunita):
                </Typography>
                <Typography variant="caption" sx={{ wordBreak: 'break-all' }}>
                  {JSON.stringify(consumption)}
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Výroba (EAN):
                </Typography>
                <Typography variant="caption" sx={{ wordBreak: 'break-all' }}>
                  {JSON.stringify(production)}
                </Typography>
              </>
            )}
          </Box>
        </Paper>
      </Group>
    </>
  );
};

export default DevEnerco;
